import { isNavigatingAway } from './pageLeaveSignal';

export type UrlWarmer = {
  /** Starts `load` unless a load of `url` runs or has succeeded. A failed
   *  load, a synchronous throw included, frees `url` and reaches `onFailure`,
   *  except while the page leaves. */
  warm: (
    url: string,
    load: () => Promise<unknown>,
    onFailure: (error: unknown) => void
  ) => void;
  forget: () => void;
};

/** One load per URL at a time; a URL loads again only after its load fails. */
export const createUrlWarmer = (): UrlWarmer => {
  const urls = new Set<string>();
  return {
    warm: (url, load, onFailure) => {
      if (urls.has(url)) return;
      urls.add(url);
      new Promise<unknown>(resolve => {
        resolve(load());
      }).catch((error: unknown) => {
        urls.delete(url);
        if (isNavigatingAway()) return;
        onFailure(error);
      });
    },
    forget: () => {
      urls.clear();
    },
  };
};
